import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AverageCompletionTime from '../../../../../components/Common/AverageCompletionTime';
import { Tooltip, TooltipContent, TooltipTrigger, } from '../../../../../components/shadcn/tooltip';
import { truncateDecimals } from '../../../../../components/utils/RoundDecimals';
import { resolveTokenUsdPrice } from '../../../../../helpers/tokenHelper';
import { RateElement } from '../../Form/FeeDetails/Rate';
export const RowWrapper = ({ children, title }) => {
    return (_jsxs("div", { className: "flex items-center w-full justify-between gap-1 py-3 px-2 text-sm", children: [_jsx("div", { className: "inline-flex items-center text-left text-secondary-text gap-1 pr-4", children: _jsx("label", { children: title }) }), _jsx("div", { className: "text-right text-primary-text", children: children })] }));
};
export const Fees = ({ quote, values, }) => {
    const feeDiscount = quote?.fee_discount;
    const hasDiscount = feeDiscount != null && feeDiscount > 0;
    // total_fee is the original fee, discounted fee is total_fee - fee_discount
    const originalFee = quote?.total_fee;
    const discountedFee = hasDiscount && originalFee !== undefined
        ? originalFee - feeDiscount
        : originalFee;
    // Calculate fees in USD
    const sourceTokenPriceInUsd = resolveTokenUsdPrice(values.fromAsset, quote);
    const originalFeeInUsd = originalFee !== undefined && sourceTokenPriceInUsd != null
        ? originalFee * sourceTokenPriceInUsd
        : null;
    // Calculate discounted fee in USD
    const discountedFeeInUsd = discountedFee !== undefined && sourceTokenPriceInUsd != null
        ? discountedFee * sourceTokenPriceInUsd
        : null;
    const displayOriginalFeeInUsd = originalFeeInUsd != null
        ? originalFeeInUsd < 0.01
            ? '<$0.01'
            : `$${originalFeeInUsd.toFixed(2)}`
        : null;
    const isFree = discountedFee !== undefined && discountedFee === 0;
    const displayLsFeeInUsd = isFree
        ? 'Free'
        : discountedFeeInUsd != null
            ? discountedFeeInUsd < 0.01
                ? '<$0.01'
                : `$${discountedFeeInUsd.toFixed(2)}`
            : null;
    const currencyName = values.fromAsset?.asset || '';
    const displayLsFee = discountedFee !== undefined
        ? truncateDecimals(discountedFee, values.fromAsset?.decimals)
        : undefined;
    return (_jsx(RowWrapper, { title: "Fees", children: _jsxs(Tooltip, { children: [_jsx(TooltipTrigger, { asChild: true, children: displayLsFeeInUsd !== undefined && (_jsxs("div", { className: "flex items-center gap-2 text-sm ml-1 font-small", children: [hasDiscount && displayOriginalFeeInUsd && (_jsx("span", { className: "line-through text-primary-text-tertiary", children: displayOriginalFeeInUsd })), _jsx("span", { className: hasDiscount || isFree
                                    ? 'text-primary-text'
                                    : '', children: displayLsFeeInUsd })] })) }), _jsxs(TooltipContent, { className: "bg-secondary-300! border-secondary-300! text-primart-text!", children: [_jsxs("span", { children: [displayLsFee || '-', " "] }), _jsx("span", { children: displayLsFee ? currencyName : '' })] })] }) }));
};
export const Estimates = ({ quote }) => {
    return (_jsx(RowWrapper, { title: "Est. time", children: _jsx(AverageCompletionTime, { avgCompletionTime: quote?.avg_completion_time }) }));
};
export const Reward = ({ reward }) => {
    return (_jsx(RowWrapper, { title: "Reward", children: _jsxs(Tooltip, { children: [_jsx(TooltipTrigger, { asChild: true, children: reward?.amount_in_usd !== undefined && (_jsxs("span", { className: "text-sm ml-1 font-small", children: ["$", reward.amount_in_usd.toFixed(2)] })) }), _jsxs(TooltipContent, { className: "bg-secondary-300! border-secondary-300! text-primart-text!", children: [_jsxs("span", { children: [reward?.amount || '-', " "] }), _jsx("span", { children: reward?.amount ? reward.token.asset : '' })] })] }) }));
};
export const Rate = ({ fromAsset, toAsset, rate }) => {
    if (!fromAsset || !toAsset || !rate) {
        return null;
    }
    return (_jsx(RowWrapper, { title: "Rate", children: _jsx(RateElement, { fromAsset: fromAsset, toAsset: toAsset, rate: rate }) }));
};
